// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cdb-tabs {
    display: flex;
    gap: 4px;
    margin-bottom: 20px;
}

.cdb-tab {
    padding: 7px 18px;
    border-radius: 8px;
    font-size: 0.8125rem;
    font-weight: 600;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    transition: all 0.15s;
}

.cdb-tab.--active {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.2);
    color: #f2f2f2;
}

.cdb-tab:hover:not(.--active) {
    color: rgba(255, 255, 255, 0.75);
}

.cdb-table-wrap {
    overflow-x: auto;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    min-width: 0;
}

.cdb-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.8rem;
}

.cdb-table th {
    padding: 10px 12px;
    text-align: left;
    font-size: 0.7rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: rgba(255, 255, 255, 0.4);
    background: rgba(255, 255, 255, 0.03);
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
    white-space: nowrap;
}

.cdb-table td {
    padding: 9px 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.82);
    vertical-align: top;
}

.cdb-table tr:last-child td {
    border-bottom: none;
}

.cdb-table tr:hover td {
    background: rgba(255, 255, 255, 0.025);
}

.cdb-name {
    font-family: monospace;
    font-size: 0.8125rem;
    font-weight: 600;
    color: #c8d8ff;
    white-space: nowrap;
}

.cdb-badge {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    border-radius: 5px;
    font-size: 0.6875rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    white-space: nowrap;
}

.cdb-badge.--analytics  { background: rgba(80,130,210,0.2); border: 1px solid rgba(80,130,210,0.35); color: #88b0e8; }
.cdb-badge.--marketing  { background: rgba(220,80,80,0.2);  border: 1px solid rgba(220,80,80,0.35);  color: #f0a8a0; }
.cdb-badge.--necessary  { background: rgba(80,180,100,0.2); border: 1px solid rgba(80,180,100,0.35); color: #7dd590; }
.cdb-badge.--functional { background: rgba(192,159,83,0.2); border: 1px solid rgba(192,159,83,0.35); color: #d4b87a; }
.cdb-badge.--security   { background: rgba(160,80,220,0.2); border: 1px solid rgba(160,80,220,0.35); color: #c88afa; }
.cdb-badge.--pending    { background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.12); color: rgba(255,255,255,0.45); }

.cdb-source-tag {
    font-size: 0.65rem;
    padding: 2px 6px;
    border-radius: 4px;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.1);
    color: rgba(255,255,255,0.45);
    white-space: nowrap;
}

.cdb-input {
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 6px;
    padding: 5px 8px;
    color: #f2f2f2;
    font-size: 0.8rem;
    width: 100%;
    min-width: 90px;
    outline: none;
}

.cdb-input:focus {
    border-color: rgba(255, 255, 255, 0.3);
}

.cdb-select {
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 6px;
    padding: 5px 8px;
    color: #f2f2f2;
    font-size: 0.8rem;
    outline: none;
    cursor: pointer;
}

.cdb-actions {
    display: flex;
    gap: 6px;
    align-items: center;
    white-space: nowrap;
}

.cdb-btn {
    padding: 5px 12px;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 600;
    border: none;
    cursor: pointer;
    transition: opacity 0.15s;
}

.cdb-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.cdb-btn.--promote {
    background: rgba(80, 200, 120, 0.2);
    border: 1px solid rgba(80, 200, 120, 0.4);
    color: #7dd590;
}

.cdb-btn.--promote:hover:not(:disabled) {
    background: rgba(80, 200, 120, 0.32);
}

.cdb-btn.--dismiss {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.45);
}

.cdb-btn.--dismiss:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.7);
}

.cdb-btn.--delete {
    background: rgba(220, 80, 80, 0.12);
    border: 1px solid rgba(220, 80, 80, 0.3);
    color: #f0a8a0;
}

.cdb-btn.--delete:hover:not(:disabled) {
    background: rgba(220, 80, 80, 0.22);
}

.cdb-count {
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.35);
    margin-left: 6px;
}

.cdb-empty {
    padding: 40px;
    text-align: center;
    color: rgba(255, 255, 255, 0.3);
    font-size: 0.875rem;
}

.cdb-toast {
    position: fixed;
    bottom: 24px;
    right: 24px;
    padding: 10px 18px;
    border-radius: 8px;
    background: rgba(30, 38, 46, 0.96);
    border: 1px solid rgba(255, 255, 255, 0.14);
    color: #f2f2f2;
    font-size: 0.8125rem;
    font-weight: 500;
    z-index: 500;
    box-shadow: 0 8px 32px rgba(0,0,0,0.4);
    backdrop-filter: blur(8px);
}

.cdb-filter-row {
    display: flex;
    gap: 8px;
    align-items: center;
    margin-bottom: 14px;
    flex-wrap: wrap;
}

.cdb-filter-input {
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 6px;
    padding: 6px 10px;
    color: #f2f2f2;
    font-size: 0.8rem;
    outline: none;
    min-width: 200px;
}

.cdb-filter-input:focus {
    border-color: rgba(255, 255, 255, 0.28);
}

.cdb-times-seen {
    font-size: 0.75rem;
    color: rgba(255,255,255,0.5);
    font-variant-numeric: tabular-nums;
}

.cdb-desc-cell {
    max-width: 260px;
    font-size: 0.775rem;
    color: rgba(255,255,255,0.6);
    line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/CookieDatabase/Style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;IACvB,0CAA0C;IAC1C,+BAA+B;IAC/B,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,+BAA+B;IAC/B,qCAAqC;IACrC,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kDAAkD;IAClD,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA,0BAA0B,gCAAgC,EAAE,uCAAuC,EAAE,cAAc,EAAE;AACrH,0BAA0B,+BAA+B,GAAG,sCAAsC,GAAG,cAAc,EAAE;AACrH,0BAA0B,gCAAgC,EAAE,uCAAuC,EAAE,cAAc,EAAE;AACrH,0BAA0B,gCAAgC,EAAE,uCAAuC,EAAE,cAAc,EAAE;AACrH,0BAA0B,gCAAgC,EAAE,uCAAuC,EAAE,cAAc,EAAE;AACrH,0BAA0B,kCAAkC,EAAE,wCAAwC,EAAE,6BAA6B,EAAE;;AAEvI;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;IAClC,uCAAuC;IACvC,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,+BAA+B;AACnC;;AAEA;IACI,mCAAmC;IACnC,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,kCAAkC;IAClC,2CAA2C;IAC3C,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,sCAAsC;IACtC,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;IAC5B,gBAAgB;AACpB","sourcesContent":[".cdb-tabs {\n    display: flex;\n    gap: 4px;\n    margin-bottom: 20px;\n}\n\n.cdb-tab {\n    padding: 7px 18px;\n    border-radius: 8px;\n    font-size: 0.8125rem;\n    font-weight: 600;\n    background: transparent;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    color: rgba(255, 255, 255, 0.5);\n    cursor: pointer;\n    transition: all 0.15s;\n}\n\n.cdb-tab.--active {\n    background: rgba(255, 255, 255, 0.08);\n    border-color: rgba(255, 255, 255, 0.2);\n    color: #f2f2f2;\n}\n\n.cdb-tab:hover:not(.--active) {\n    color: rgba(255, 255, 255, 0.75);\n}\n\n.cdb-table-wrap {\n    overflow-x: auto;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    min-width: 0;\n}\n\n.cdb-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.8rem;\n}\n\n.cdb-table th {\n    padding: 10px 12px;\n    text-align: left;\n    font-size: 0.7rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: rgba(255, 255, 255, 0.4);\n    background: rgba(255, 255, 255, 0.03);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n    white-space: nowrap;\n}\n\n.cdb-table td {\n    padding: 9px 12px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    color: rgba(255, 255, 255, 0.82);\n    vertical-align: top;\n}\n\n.cdb-table tr:last-child td {\n    border-bottom: none;\n}\n\n.cdb-table tr:hover td {\n    background: rgba(255, 255, 255, 0.025);\n}\n\n.cdb-name {\n    font-family: monospace;\n    font-size: 0.8125rem;\n    font-weight: 600;\n    color: #c8d8ff;\n    white-space: nowrap;\n}\n\n.cdb-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 2px 8px;\n    border-radius: 5px;\n    font-size: 0.6875rem;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    white-space: nowrap;\n}\n\n.cdb-badge.--analytics  { background: rgba(80,130,210,0.2); border: 1px solid rgba(80,130,210,0.35); color: #88b0e8; }\n.cdb-badge.--marketing  { background: rgba(220,80,80,0.2);  border: 1px solid rgba(220,80,80,0.35);  color: #f0a8a0; }\n.cdb-badge.--necessary  { background: rgba(80,180,100,0.2); border: 1px solid rgba(80,180,100,0.35); color: #7dd590; }\n.cdb-badge.--functional { background: rgba(192,159,83,0.2); border: 1px solid rgba(192,159,83,0.35); color: #d4b87a; }\n.cdb-badge.--security   { background: rgba(160,80,220,0.2); border: 1px solid rgba(160,80,220,0.35); color: #c88afa; }\n.cdb-badge.--pending    { background: rgba(255,255,255,0.06); border: 1px solid rgba(255,255,255,0.12); color: rgba(255,255,255,0.45); }\n\n.cdb-source-tag {\n    font-size: 0.65rem;\n    padding: 2px 6px;\n    border-radius: 4px;\n    background: rgba(255,255,255,0.06);\n    border: 1px solid rgba(255,255,255,0.1);\n    color: rgba(255,255,255,0.45);\n    white-space: nowrap;\n}\n\n.cdb-input {\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 6px;\n    padding: 5px 8px;\n    color: #f2f2f2;\n    font-size: 0.8rem;\n    width: 100%;\n    min-width: 90px;\n    outline: none;\n}\n\n.cdb-input:focus {\n    border-color: rgba(255, 255, 255, 0.3);\n}\n\n.cdb-select {\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 6px;\n    padding: 5px 8px;\n    color: #f2f2f2;\n    font-size: 0.8rem;\n    outline: none;\n    cursor: pointer;\n}\n\n.cdb-actions {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n    white-space: nowrap;\n}\n\n.cdb-btn {\n    padding: 5px 12px;\n    border-radius: 6px;\n    font-size: 0.75rem;\n    font-weight: 600;\n    border: none;\n    cursor: pointer;\n    transition: opacity 0.15s;\n}\n\n.cdb-btn:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n}\n\n.cdb-btn.--promote {\n    background: rgba(80, 200, 120, 0.2);\n    border: 1px solid rgba(80, 200, 120, 0.4);\n    color: #7dd590;\n}\n\n.cdb-btn.--promote:hover:not(:disabled) {\n    background: rgba(80, 200, 120, 0.32);\n}\n\n.cdb-btn.--dismiss {\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    color: rgba(255, 255, 255, 0.45);\n}\n\n.cdb-btn.--dismiss:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.1);\n    color: rgba(255, 255, 255, 0.7);\n}\n\n.cdb-btn.--delete {\n    background: rgba(220, 80, 80, 0.12);\n    border: 1px solid rgba(220, 80, 80, 0.3);\n    color: #f0a8a0;\n}\n\n.cdb-btn.--delete:hover:not(:disabled) {\n    background: rgba(220, 80, 80, 0.22);\n}\n\n.cdb-count {\n    font-size: 0.75rem;\n    color: rgba(255, 255, 255, 0.35);\n    margin-left: 6px;\n}\n\n.cdb-empty {\n    padding: 40px;\n    text-align: center;\n    color: rgba(255, 255, 255, 0.3);\n    font-size: 0.875rem;\n}\n\n.cdb-toast {\n    position: fixed;\n    bottom: 24px;\n    right: 24px;\n    padding: 10px 18px;\n    border-radius: 8px;\n    background: rgba(30, 38, 46, 0.96);\n    border: 1px solid rgba(255, 255, 255, 0.14);\n    color: #f2f2f2;\n    font-size: 0.8125rem;\n    font-weight: 500;\n    z-index: 500;\n    box-shadow: 0 8px 32px rgba(0,0,0,0.4);\n    backdrop-filter: blur(8px);\n}\n\n.cdb-filter-row {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    margin-bottom: 14px;\n    flex-wrap: wrap;\n}\n\n.cdb-filter-input {\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 6px;\n    padding: 6px 10px;\n    color: #f2f2f2;\n    font-size: 0.8rem;\n    outline: none;\n    min-width: 200px;\n}\n\n.cdb-filter-input:focus {\n    border-color: rgba(255, 255, 255, 0.28);\n}\n\n.cdb-times-seen {\n    font-size: 0.75rem;\n    color: rgba(255,255,255,0.5);\n    font-variant-numeric: tabular-nums;\n}\n\n.cdb-desc-cell {\n    max-width: 260px;\n    font-size: 0.775rem;\n    color: rgba(255,255,255,0.6);\n    line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
